var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "row justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_c('span', [_vm._v("目前第 " + _vm._s(_vm.localCurrentPage) + " 頁 / 總共 " + _vm._s(_vm.totalPages) + " 頁")])]), _c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_vm.totalRows > 0 ? _c('b-pagination', {
    staticClass: "my-auto",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.localPerPage
    },
    on: {
      "change": _vm.onChangePage
    },
    model: {
      value: _vm.localCurrentPage,
      callback: function callback($$v) {
        _vm.localCurrentPage = $$v;
      },
      expression: "localCurrentPage"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_c('span', [_vm._v("每頁顯示數量：")]), _c('b-form-select', {
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "change": _vm.onPerPageChange
    },
    model: {
      value: _vm.localPerPage,
      callback: function callback($$v) {
        _vm.localPerPage = $$v;
      },
      expression: "localPerPage"
    }
  }), _c('span', [_vm._v(" / 總數量: " + _vm._s(_vm.totalRows))])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }